import { StoryblokClientConfig } from '@shared/types';

const getAccessToken = (config: StoryblokClientConfig, params: any): string | undefined =>
  params.version === 'draft' && !!config.previewToken ? config.previewToken : config.token;

export default getAccessToken;
